<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate [formGroup]="StudentEdit">
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-24 mg-b-5">All Student Records</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">Student Data</li>
                            </ol>
                        </div>
                    </div>
                    <mat-accordion>
                        <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header (click)="getData('PersonalDetails')">
                                <mat-panel-title>
                                    Personal Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="PersonalDetail">
                                        <tr  *ngFor="let pdetail of getPersonalDetailControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                {{pdetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Required</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(pdetail)">Update</button>
                                                </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header (click)="getData('ContactDetails')" >
                                <mat-panel-title>
                                    Contact Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="ContactDetail">
                                        <tr *ngFor="let cdetail of getContactDetailControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{cdetail.name}}</mat-label> -->
                                                {{cdetail.controls['FormName'].value}}
                                                <!-- {{cdetail.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(cdetail)">Update</button>
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (click)="getData('ReserveDetails')" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Reservation Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                        Action
                                    </th>
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="RegisterDetail">
                                        <tr *ngFor="let regdetail of getRegisterDetailControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{regdetail.name}}</mat-label> -->
                                                {{regdetail.controls['FormName'].value}}
                                                <!-- {{regdetail.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{regdetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(regdetail)">Update</button>
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (click)="getData('QualifyDetails')" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Qualification Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                        Action
                                    </th>
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="QualificationDetail">
                                        <tr *ngFor="let quadetail of getQualificationDetailControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{quadetail.name}}</mat-label> -->
                                                {{quadetail.controls['FormName'].value}}
                                                 <!-- {{quadetail.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{quadetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(quadetail)">Update</button>
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (click)="getData('AdditionalDetail')" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Additional Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                        Action
                                    </th>
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="AdditionalDetail">
                                        <tr *ngFor="let addetail of getAdditionalDetailControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{addetail.name}}</mat-label> -->
                                                 <!-- {{addetail.name}}  -->
                                                 {{addetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{addetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(addetail)">Update</button>
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (click)="getData('PhotoSign')" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Photo & Signature
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                        Action
                                    </th>
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="PhotoSign">
                                        <tr *ngFor="let photoS of getPhotoSignControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{photoS.name}}</mat-label> -->
                                                 <!-- {{photoS.name}}  -->
                                                 {{photoS.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{photoS.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(photoS)">Update</button>
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (click)="getData('AdmDetails')" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Admission Details
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                        Action
                                    </th>
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="AdmissionDetail">
                                        <tr *ngFor="let admdetail of getAdmissionDetailControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{admdetail.name}}</mat-label> -->
                                                 <!-- {{admdetail.name}}  -->
                                                 {{admdetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{admdetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(admdetail)">Update</button>
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Document Upload
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                        Action
                                    </th>
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="Document">
                                        <tr *ngFor="let doc of getDocumentControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{doc.name}}</mat-label> -->
                                                 <!-- {{doc.name}}  -->
                                                 {{doc.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{doc.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field>
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(doc)">Update</button>
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>

                </div>
            </div>
        </div>
    </form>
</body>